import CreateLocationError from "./CreateLocationError";

export default class LocationRecordAlreadyExistsError extends CreateLocationError {

}